<template>
  <h1>welcome</h1>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    if(Vue.store.state.me === null) {
      next(vm => {
        vm.$router.push('login')
      })
    } else {
      next(vm => {
        vm.$router.push('log/1v1')
      })
    }
  }
}
</script>
